import React, {Component} from "react";
import { Navigate } from 'react-router-dom';
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import RootLayout from "./layout/RootLayoutComponent";
import Home from "./common/HomeComponent";
import Login from "./auth/LoginComponent";
import ResetPasswordForm from './auth/PasswordResetComponent';
import NotAuthorized from './auth/NotAuthorizedComponent';
import MyProfile from './myaccount/MyProfileComponent';

import Equipment from './adminData/equipment/EquipmentComponent';
import RsvtiEquipment from './rsvti/equipment/RsvtiEquipmentComponent';

import Status from './admin/StatusComponent';

import {loginUser, logoutUser, changePasswordChallenge} from '../redux/actionCreators/ActionCreatorsAuth';
import {setBucketValue} from '../redux/actionCreators/ActionCreatorsBucket';
import {fetchAllClients, postClient, patchClient} from '../redux/actionCreators/ActionCreatorsClients';
import {fetchSubcontractedBCU, fetchSubcontracted, fetchClientSubcontractanti, postClientSubcon, patchClientSubcon } from "../redux/actionCreators/ActionCreatorsClientsSubcon";
import {fetchUsers, postUser, patchUser} from '../redux/actionCreators/ActionCreatorsUsers';
import {fetchEmployersForClient, fetchEmployer, postEmployer, patchEmployer} from '../redux/actionCreators/ActionCreatorsEmployers';
import {postEmployerWorksite, patchEmployerWorksite} from '../redux/actionCreators/ActionCreatorsEmployerWorksites';
import {fetchEmployees, postEmployee, patchEmployee} from '../redux/actionCreators/ActionCreatorsEmployees';
import {fetchAuthzs} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import {postAuthISCIR, patchAuthISCIR, patchAuthzsStampDate} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import { postAuthzIscirImage } from "../redux/actionCreators/ActionCreatorsAuthorizations"; 
import {postAuthzInternal, patchAuthzInternal, patchAuthzsCertDate} from '../redux/actionCreators/ActionCreatorsAuthorizations';
import { postAuthzInternalCert } from "../redux/actionCreators/ActionCreatorsAuthorizations";
import {fetchCourses, postEmployeeCourse, patchEmployeeCourse, postEmployeeCourseCert} from '../redux/actionCreators/ActionCreatorsEmployeeCourses';
import {fetchRsvtiTasks, postRsvtiTask, patchRsvtiTask} from '../redux/actionCreators/ActionCreatorsRsvtiTasks';
import { fetchRsvtiOperators } from "../redux/actionCreators/ActionCreatorsRsvtiOperators";
import {fetchCorCodes} from '../redux/actionCreators/ActionCreatorsStaticData';

import dayjs from 'dayjs';

import CustomSnackBar from './custom/CustomSnackbar';
import AuthContext from "./context/AuthContext";
import BucketContext from "./context/BucketContext";
import * as AuthC from '../utils/auth/AuthCognito';
import * as Security from '../utils/auth/Security';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';

import * as PageHandlerClient from './PageHandlerClient';
import * as PageHandlerUser from './PageHandlerUser';
import * as PageHandlerEmployer from './PageHandlerEmployer';
import * as PageHandlerEmployee from './PageHandlerEmployee';
import * as PageHandlerRsvtiTask from './PageHandlerRsvtiTask';
import * as PageHandlerCalendar from './PageHandlerCalendar';
import * as PageHandlerReports from './PageHandlerReports';
import * as AFStoreDataRefresh from './AFStoreDataRefresh';
import * as AFStateHelper from './AFStateHelper';

const mapStateToProps = state => {
  return {
    auth: state.auth,    
    bucket: state.bucket,
    users: state.users,
    clients: state.clients,
    clientSubcontractors: state.clientSubcontractors,
    clientSubcontracted: state.clientSubcontracted,
    employers: state.employers,
    worksites: state.worksites,
    employees: state.employees,
    authorizations: state.authorizations,
    employeeCourses: state.employeeCourses,
    rsvtiOperators: state.rsvtiOperators,
    reminders: state.reminders,
    equipment: state.equipment,
    rsvtiTasks: state.rsvtiTasks,
    staticData: state.staticData,
  }
}

const mapDispatchToProps = dispatch => ({

    // Authentication
    loginUser: (authData, onLoginCallback) => dispatch(loginUser(authData, onLoginCallback)),
    logoutUser: () => dispatch(logoutUser()),
    changePasswordChallenge: (authCredentials) => dispatch(changePasswordChallenge(authCredentials)),
    // Bucket
    setBucketValue: (value) => dispatch(setBucketValue(value)),
    // Clients
    // fetchClients: () => dispatch(fetchClients()),
    fetchAllClients: () => dispatch(fetchAllClients()),
    // postClient: (client) => dispatch(postClient(client)),
    // patchClient: (client) => dispatch(patchClient(client)),
    // Client Subcontractors
    fetchSubcontractedBCU: (clientId) => dispatch(fetchSubcontractedBCU(clientId)),
    // fetchSubcontracted: (clientId) => dispatch(fetchSubcontracted(clientId)),
    // fetchClientSubcons: (clientId) => dispatch(fetchClientSubcontractanti(clientId)),
    // postClientSubcon: (subcon) => dispatch(postClientSubcon(subcon)),
    // patchClientSubcon: (subcon) => dispatch(patchClientSubcon(subcon)),
    // Users
    // fetchUsers: (clientId) => dispatch(fetchUsers(clientId)),
    // postUser: (user) => dispatch(postUser(user)),
    // patchUser: (user, clientId) => dispatch(patchUser(user, clientId)),
    // Employers
    // fetchEmployersForClient: (clientId) => dispatch(fetchEmployersForClient(clientId)),
    // fetchEmployer: (employerId) => dispatch(fetchEmployer(employerId)),
    // postEmployer: (employer) => { dispatch(postEmployer(employer)) },
    // patchEmployer: (employer) => dispatch(patchEmployer(employer)),
    // Employer Work-Sites
    // fetchEmployerWorksites: (params) => dispatch(fetchEmployerWorksites(params)),
    // postEmployerWorksite: (worksite) => dispatch(postEmployerWorksite(worksite)),
    // patchEmployerWorksite: (worksite) => dispatch(patchEmployerWorksite(worksite)),
    // Employees
    // fetchEmployees: (employerId) => dispatch(fetchEmployees(employerId)),
    // postEmployee: (employee) => dispatch(postEmployee(employee)),
    // patchEmployee: (employee) => dispatch(patchEmployee(employee)),
    // Authorizations
    // fetchAuthzs: (employeeId) => dispatch(fetchAuthzs(employeeId)),
    // Authorizations - ISCIR
    // postAuthISCIR: (authorization, reminder) => dispatch(postAuthISCIR(authorization, reminder)),
    // patchAuthISCIR: (authorization, reminder) => dispatch(patchAuthISCIR(authorization, reminder)),
    // patchAuthzsStampDate: (employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate) => dispatch(patchAuthzsStampDate(employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate)),
    // postAuthzIscirImage:(fileName, imageBase64, employerId, employeeId, authzId, imageType) => dispatch(postAuthzIscirImage(fileName, imageBase64, employerId, employeeId, authzId, imageType)),
    // Authorizations - Internal
    // postAuthzInternal: (authorization, reminder) => dispatch(postAuthzInternal(authorization, reminder)),
    // patchAuthzInternal: (authorization, reminder) => dispatch(patchAuthzInternal(authorization, reminder)),
    // patchAuthzsCertDate: (taskId, employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate) => dispatch(patchAuthzsCertDate(taskId, employerId, updatedAuthzArray, notUpdatedAuthzArray, stampDate)),
    // postAuthzInternalCert: (fileName, certBase64, employerId, employeeId, authzId) => dispatch(postAuthzInternalCert(fileName, certBase64, employerId, employeeId, authzId)),
    // Courses
    // fetchCourses: (employeeId) => dispatch(fetchCourses(employeeId)),
    // postEmployeeCourse: (course) => dispatch(postEmployeeCourse(course)),
    // patchEmployeeCourse: (course) => dispatch(patchEmployeeCourse(course)),
    // postEmployeeCourseCert: (fileName, certBase64, employerId, employeeId, courseId) => dispatch(postEmployeeCourseCert(fileName, certBase64, employerId, employeeId, courseId)),
    // RSVTI Task
    // fetchRsvtiTasks: (clientId) => dispatch(fetchRsvtiTasks(clientId)),
    // postRsvtiTask: (task) => dispatch(postRsvtiTask(task)),
    // patchRsvtiTask: (task) => dispatch(patchRsvtiTask(task)),
    // RSVTI Operators
    // fetchRsvtiOperators: (clientId, worksiteId) => dispatch(fetchRsvtiOperators(clientId, worksiteId)),
    // Static Data
    fetchCorCodes: () => dispatch(fetchCorCodes()),

});


class Main extends Component {


    componentDidMount() {
        console.log("=========Component Did Mount==============");
        if(this.props.auth.isAuthenticated) {
            this.props.fetchCorCodes();
            this.props.fetchAllClients();
            this.props.fetchSubcontractedBCU(this.props.auth.afUser.generalSection.clientId);
        }
    }  
    
    render() {

        // This is callback method called when the user logs in
        const onSuccessfulLogin = (authUser) => {
            console.log("> Logged in");
        
            try{
                if(this.props.staticData.corCodes.length === 0 && 
                    this.props.staticData.status === ReduxDataStatus.IDLE) {
            
                    this.props.fetchCorCodes();
                }

                this.props.fetchAllClients();
                this.props.fetchSubcontractedBCU(authUser.generalSection.clientId);
            
            }
            catch(err) {
                console.log(err);
            }
        }
    

        const HomePage = () => {
            console.log('--> HomePage');

            var dataStatus;
            if(Security.isUserOfClientEmployer()) {
                if(this.props.clients.status === ReduxDataStatus.SUCCEEDED && 
                    this.props.worksites.status === ReduxDataStatus.SUCCEEDED) {

                    dataStatus = ReduxDataStatus.SUCCEEDED;
                }
                else{
                    dataStatus = ReduxDataStatus.LOADING;
                }
            }
            else{
                dataStatus = ReduxDataStatus.SUCCEEDED;
            }

            return (
                <Home 
                    loadComponentData={HomeDataLoader}
                    clients={this.props.clients.clients}
                    worksites={this.props.worksites.worksites}
                    dataStatus={dataStatus}
                />
            );
        }

        const HomeDataLoader = () => {
            if(Security.isUserOfClientEmployer()) {
                if(this.props.clients.status === ReduxDataStatus.SUCCEEDED) {
                    const myEmployerId = AFStateHelper.getSiuClientEmployerEID();
    
                    AFStoreDataRefresh.RefreshWorksiteByEIDCachedData(myEmployerId);
                    // AFStoreDataRefresh.RefreshWorksiteCachedData({employerId: myEmployerId});
                }
            }
        }

        ////////////////////// Authorization Section /////////////////////
        /////////////////////////////////////////////////////////////////
        const LoginPage = () => {
            console.log('--> LoginPage');
            return (
                <Login
                    auth={this.props.auth}
                    loginUser={this.props.loginUser}
                    onLoginCallback={onSuccessfulLogin}
                    changePasswordChallenge={this.props.changePasswordChallenge} 
                />

            );
        }

        const ResetPasswordPage = () => {
            return(
                <ResetPasswordForm />                
            );
        }

        ////////////////////// MyProfile Section /////////////////////
        //////////////////////////////////////////////////////////////
        const MyProfilePage = () => {
            const myClient = AFStateHelper.getSiuClient();
            return(
                <MyProfile 
                    loadComponentData={ProfileDataLoader}
                    client={myClient}
                />
            );
        }

        const ProfileDataLoader = () => {
            AFStoreDataRefresh.RefreshClientsCachedData()
        }


        const EquipmentPage = () => {
            return(
                <Equipment 
                    equipment={this.props.equipment} 
                />
            );
        }

        const RsvtiEquipmentPage = () => {
            return (
                <RsvtiEquipment 
                    equipment={this.props.equipment}
                />
            );
        }

        const StatusPage = () => {
            return(
                <Status />
            );
        }
        

        const ProtectedRoute = ({children}) => {
            const location = useLocation();
            
            console.log('>>> Session Active: ' + AuthC.isCachedUserSessionActive());
            if(AuthC.isCachedUserSessionActive()) { 
                if(Security.isUserAuthorizedForPath(location.pathname)){
                    return children;
                }
                else {
                    console.log('Not authorized: ' + location.pathname);
                    return <Navigate to="/notauthorized" replace />;
                }
            }
            else {
                return <Navigate to="/login" replace />;
            }
        }


        return (
            <div>
                <AuthContext.Provider value={{ isAuthenticated: this.props.auth.isAuthenticated, 
                                               username: this.props.auth?.username,
                                               afUser: this.props.auth.isAuthenticated ? this.props.auth.afUser : null,
                                               subcontracted: this.props.auth.subcontracted ? this.props.auth.subcontracted : []
                                             }} 
                >
                <BucketContext.Provider value={{
                                                 bucket: this.props.bucket.bucket,
                                                 setBucketValue: this.props.setBucketValue
                                               }}
                >

                    <CustomSnackBar bucket={this.props.bucket.bucket} setBucketValue={this.props.setBucketValue}/>

                    <RouterProvider router={createBrowserRouter(createRoutesFromElements(
                            <Route element={<RootLayout logoutUser={this.props.logoutUser} />}>
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/password-reset" element={<ResetPasswordPage />} />
                                <Route path="/notauthorized" element={ <NotAuthorized />} />

                                <Route path="/myaccount/profile" element={<ProtectedRoute > <MyProfilePage /> </ProtectedRoute>} />

                                <Route path="/status" element={<ProtectedRoute > <StatusPage /> </ProtectedRoute>} />

                                <Route path="/home" element={<ProtectedRoute > <HomePage /> </ProtectedRoute>} />

                                <Route exact path="/clients" element={<ProtectedRoute > <PageHandlerClient.ClientsPage /> </ProtectedRoute>} />
                                <Route exact path="/clients/newclient" element={<ProtectedRoute> <PageHandlerClient.ClientNewPage /> </ProtectedRoute>} />
                                <Route exact path="/clients/:clientId" element={<ProtectedRoute> <PageHandlerClient.ClientManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/myclient" element={<ProtectedRoute> <PageHandlerClient.MyClientPage /> </ProtectedRoute>} />
                                <Route exact path="/clients/subcon/newsubcon" element={<ProtectedRoute> <PageHandlerClient.ClientSubcontractorNewPage /> </ProtectedRoute>} />
                                <Route exact path="/clients/subcon/:subconId" element={<ProtectedRoute> <PageHandlerClient.ClientSubcontractorManagementPage /> </ProtectedRoute>} />

                                <Route exact path="/sysusers" element={<ProtectedRoute> <PageHandlerUser.SysUsersPage /> </ProtectedRoute>} />
                                <Route exact path="/sysusers/:userId" element={<ProtectedRoute> <PageHandlerUser.SysUserManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/sysusers/newuser" element={<ProtectedRoute> <PageHandlerUser.SysUserNewPage /> </ProtectedRoute>} />
                                <Route exact path="/users" element={<ProtectedRoute> <PageHandlerUser.UsersPage /> </ProtectedRoute>} />
                                <Route exact path="/users/:userId" element={<ProtectedRoute> <PageHandlerUser.UserManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/users/newuser" element={<ProtectedRoute> <PageHandlerUser.UserNewPage /> </ProtectedRoute>} />

                                <Route exact path="/employers" element={<ProtectedRoute > <PageHandlerEmployer.EmployersPage /> </ProtectedRoute>} />
                                <Route exact path="/employers/:employerId" element={<ProtectedRoute > <PageHandlerEmployer.EmployerManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/newemployer" element={<ProtectedRoute > <PageHandlerEmployer.EmployerNewPage /> </ProtectedRoute>} />
                                <Route exact path="/myemployer" element={<ProtectedRoute > <PageHandlerEmployer.MyEmployerPage /> </ProtectedRoute>} />
                                <Route exact path="/employers/worksites/:worksiteId" element={<ProtectedRoute > <PageHandlerEmployer.WorksiteManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/employers/new-worksite" element={<ProtectedRoute > <PageHandlerEmployer.WorksiteNewPage /> </ProtectedRoute>} />

                                <Route exact path="/employees" element={<ProtectedRoute > <PageHandlerEmployee.EmployeesPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/:employeeId" element={<ProtectedRoute > <PageHandlerEmployee.EmployeeManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/newemployee" element={<ProtectedRoute > <PageHandlerEmployee.EmployeeNewPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/newauthz-iscir" element={<ProtectedRoute > <PageHandlerEmployee.AuthzIscirNewPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/authzs/iscir/:authzId" element={<ProtectedRoute > <PageHandlerEmployee.AuthzIscirManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/newauthz-internal" element={<ProtectedRoute > <PageHandlerEmployee.AuthzInternalNewPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/authzs/internal/:authzId" element={<ProtectedRoute > <PageHandlerEmployee.AuthzInternalManagementPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/newauthzcourse" element={<ProtectedRoute > <PageHandlerEmployee.AuthzIscirCourseNewPage /> </ProtectedRoute>} />
                                <Route exact path="/employees/authzcourse/:courseId" element={<ProtectedRoute > <PageHandlerEmployee.AuthzIscirCourseManagePage /> </ProtectedRoute>} />

                                <Route exact path="/equipment" element={<ProtectedRoute > <EquipmentPage /> </ProtectedRoute>} />

                                <Route exact path="/deserventi-calendar" element={<ProtectedRoute > <PageHandlerCalendar.DeserventiCalendarPage /> </ProtectedRoute>} />

                                <Route exact path="/rsvti/deserventi/tasks" element={<ProtectedRoute > <PageHandlerRsvtiTask.TasksDeserventiPage /> </ProtectedRoute>} />
                                <Route exact path="/rsvti/deserventi/tasks/new-couponstamp" element={<ProtectedRoute > <PageHandlerRsvtiTask.TaskDeserventiCouponStampNewPage /> </ProtectedRoute>} />
                                <Route exact path="/rsvti/deserventi/tasks/couponstamp/:taskId" element={<ProtectedRoute > <PageHandlerRsvtiTask.TaskDeserventiCouponStampManagePage /> </ProtectedRoute>} />
                                <Route exact path="/rsvti/deserventi/tasks/new-certificate" element={<ProtectedRoute > <PageHandlerRsvtiTask.TaskDeserventiCertificateNewPage /> </ProtectedRoute>} />
                                <Route exact path="/rsvti/deserventi/tasks/certificate/:taskId" element={<ProtectedRoute > <PageHandlerRsvtiTask.TaskDeserventiCertificateManagePage /> </ProtectedRoute>} />

                                <Route exact path="/rsvti/equipment" element={<ProtectedRoute > <RsvtiEquipmentPage /> </ProtectedRoute>} />

                                <Route exact path="/rsvti/reports" element={<ProtectedRoute > <PageHandlerReports.RsvtiReportPage /> </ProtectedRoute>} />

                                <Route path="*" element={<Navigate to="/home" replace />} />
                            </Route>
                        ))}
                    />

                </BucketContext.Provider>
                </AuthContext.Provider>
            </div>
        );
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
